import React, { useState } from 'react';
import '../../css/modals/SimpleModal.css';
import { IoClose } from 'react-icons/io5';

function SimpleModal({ close, handlerClose, handleCloseModal, url }) {
	return (
		<div className={`Inscriptions ${close ? 'close' : ''}`} onClick={handleCloseModal}>
			<div className={`Inscriptions-content ${close ? 'close' : ''}`}>
				<button
					className='Inscriptions-close-btn'
					onClick={() => {
						handlerClose();
					}}
				>
					<IoClose />
				</button>

				<div className='container-info'>
					<div className='container-title'>
						<h2>¡Advertencia!</h2>
					</div>
					<p>
						Envía el comprobante de pago a
						<b>
							{' '}
							<u>coordinacion@libeluniversity.org</u>{' '}
						</b>
						para recibir el formulario de inscripción. Este paso es esencial para acceder al
						curso/máster. <br />
					</p>

					<span> ¿Algún asesor te ayudó a realizar esta compra? </span>
				</div>
				<div className='btn-container'>
					<a
						href={url?.url}
						target='_blank'
						className='btn-camb'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Ninguno
					</a>
					<a
						href={url?.Viviana}
						target='_blank'
						className='btn-camb'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Viviana
					</a>
					{/* <a
						href={url?.Julian}
						target='_blank'
						className='btn-camb'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						Julián
					</a> */}
					<a
						href={'https://wa.link/fvjvug'}
						target='_blank'
						className='btn-camb'
						onClick={() =>
							setTimeout(() => {
								handlerClose();
							}, 2000)
						}
					>
						David
					</a>
				</div>

				<div className='container-info'>
					<p style={{ marginBottom: '24px' }}>
						Si tu asesor no aparece en las opciones o no tuviste asesor, selecciona
						<b>"Ninguno".</b>
					</p>
				</div>
			</div>
		</div>
	);
}

export default SimpleModal;
